<div *ngIf="viewModel.hasRange$ | async; else SinglePrice" class="product-variant-price">
  {{ viewModel.rangedPrice$ | async }}
</div>
<ng-template #SinglePrice>
  <app-column-primary-price
    [menu]="viewModel.cardStackMenu$ | async"
    [section]="viewModel.cardStack$ | async"
    [colVm]="viewModel.spoofedColViewModel$ | async"
    [rowVm]="viewModel.cardData$ | async"
    [locConfig]="viewModel.locationConfig$ | async"
    [locationId]="viewModel.locationId$ | async"
    [productStylingVm]="viewModel">
  </app-column-primary-price>
</ng-template>
